// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 2H19V9H5V2ZM2 11H22V13H2V11ZM5 15H19V22H5V15Z"}}]};

const ComponentDividerVerticalFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-divider-vertical-filled',
    ref,
    icon: element,
  },
));

ComponentDividerVerticalFilledIcon.displayName = 'ComponentDividerVerticalFilledIcon';

export default ComponentDividerVerticalFilledIcon;
